/**
 * This feature's routes, as constants.
 *
 * Two groups, mounted in different applications. The back office's are the
 * ledger — every customer's documents — and the portal's are one customer's
 * own. They are separate paths rather than one screen with a filter because
 * they are separate audiences: `/facturation` is a desk, `/factures` is "my
 * invoices", and a customer should never see a URL that implies the other
 * exists.
 *
 * Separate from `routes.tsx` so a screen can link to another without importing
 * the module that builds the route table — which would be a cycle.
 */

export const BILLING_PATHS = {
  ledger: "/facturation",
  document: "/facturation/$id",
  /** One customer's situation, reached from a row in the ledger. */
  statement: "/facturation/clients/$id",
} as const;

export const BILLING_PORTAL_PATHS = {
  documents: "/factures",
  statement: "/situation-du-compte",
} as const;
